import { ACC_FILES_EXTRACTION_SCOPE } from './remote-routes-helpers/accFilesExtraction';
import { ACC_SHEETS_PUBLISH_SCOPE } from './remote-routes-helpers/accSheetsPublish';
import { Remotes } from './types';

export default [
  {
    url: 'https://assets.project-list.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accProjectList',
    moniker: 'wpxprojl',
  },
  {
    url: '/assets/demo-app/assets-no-cache/remoteEntry.js',
    scope: 'accDemoApp',
    moniker: 'wbpltdmo',
  },
  {
    url: '/assets/mkto/assets-no-cache/remoteEntry.js',
    scope: 'accMkto',
    moniker: 'wpxmkto',
  },
  {
    url: '/assets/correspondence/assets-no-cache/remoteEntry.js',
    scope: 'accCorrespondence',
  },
  {
    url: '/assets/meetings/assets-no-cache/remoteEntry.js',
    scope: 'accMeetings',
  },
  {
    url: '/assets/photos/assets-no-cache/remoteEntry.js',
    scope: 'acsPhotos',
  },
  {
    url: '/assets/rfis/assets-no-cache/remoteEntry.js',
    scope: 'accRfis',
    moniker: 'acsrfife',
  },
  {
    url: '/assets/schedule/assets-no-cache/remoteEntry.js',
    scope: 'accSchedule',
  },
  {
    url: '/assets/docs/assets-no-cache/remoteEntry.js',
    scope: 'accDocs',
  },
  {
    url: '/assets/sheets/assets-no-cache/remoteEntry.js',
    scope: 'accSheets',
  },
  {
    url: 'https://sheet-publishing-assets.acc-staging.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: ACC_SHEETS_PUBLISH_SCOPE,
  },
  {
    url: 'https://files-extraction-assets.acc-staging.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: ACC_FILES_EXTRACTION_SCOPE,
  },
  {
    url: '/assets/home/assets-no-cache/remoteEntry.js',
    scope: 'accUserHome',
    moniker: 'acsuserh',
  },
  {
    url: 'https://insight-assets.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'acsInsight',
    moniker: 'acsiq',
  },
  {
    url: '/assets/submittals/assets-no-cache/remoteEntry.js',
    scope: 'accSubmittals',
  },
  {
    url: '/assets/specs/assets-no-cache/remoteEntry.js',
    scope: 'accSpecs',
  },
  {
    url: '/assets/notifications/assets-no-cache/remoteEntry.js',
    scope: 'accNotifications',
  },
  {
    url: '/assets/handover/assets-no-cache/remoteEntry.js',
    scope: 'accHandover',
  },
  {
    url: '/assets/share/assets-no-cache/remoteEntry.js',
    scope: 'accDocsShare',
  },
  {
    url: '/assets/components/assets-no-cache/remoteEntry.js',
    scope: 'accLibrary',
  },
  {
    url: '/assets/bridge/assets-no-cache/remoteEntry.js',
    scope: 'accBridge',
  },
  {
    url: '/assets/admin/assets-no-cache/remoteEntry.js',
    scope: 'accAdminClient',
    moniker: 'acsadmin',
  },
  {
    url: '/assets/template-admin/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateAdmin',
  },
  {
    url: '/assets/template-settings/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateSettings',
  },
  {
    url: '/assets/apps/assets-no-cache/remoteEntry.js',
    scope: 'accApps',
  },
  {
    url: '/assets/reports/assets-no-cache/remoteEntry.js',
    scope: 'accReports',
  },
  {
    url: '/assets/autospecs/assets-no-cache/remoteEntry.js',
    scope: 'accAutoSpecs',
  },
  {
    url: 'https://cost.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accCost',
  },
  {
    url: '/assets/issues/assets-no-cache/remoteEntry.js',
    scope: 'accIssues',
  },
  {
    url: '/assets/takeoff/assets-no-cache/remoteEntry.js',
    scope: 'accTakeoff',
  },
  {
    url: 'https://insight-builder.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'insightBuilder',
  },
  {
    url: '/assets/model/assets-no-cache/remoteEntry.js',
    scope: 'accModelCoordination',
    moniker: 'modcoor',
  },
  {
    url: 'https://parameters-service.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accParameters',
  },
  {
    url: 'https://assets-stg.acsastfe.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accAssets',
  },
  {
    url: 'https://assets.acc-forms-fe.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accForms',
  },
  {
    url: 'https://assets.acc-network-api-components.acc-staging.apac.autodesk.com/assets-no-cache/remoteEntry.js',
    scope: 'accNetworkApiComponents',
  },
] satisfies Remotes;
